import { render, staticRenderFns } from "./InceptionAssessmentAiWrapper.vue?vue&type=template&id=01cb5f24&scoped=true"
import script from "./InceptionAssessmentAiWrapper.vue?vue&type=script&lang=ts"
export * from "./InceptionAssessmentAiWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb5f24",
  null
  
)

export default component.exports